import React from 'react';

const STEP_LABELS = ['Profissional', 'Serviço', 'Data', 'Horário', 'Dados'];

/**
 * PublicScheduleStepper
 * Stepper circular premium com 5 etapas conectadas por linha.
 * current: índice 0-4 do step ativo.
 */
export default function PublicScheduleStepper({ current }) {
    return (
        <div className="ps-stepper">
            {STEP_LABELS.map((label, i) => {
                const isDone = i < current;
                const isActive = i === current;
                return (
                    <React.Fragment key={i}>
                        <div className="ps-stepper__item">
                            <div
                                className={[
                                    'ps-stepper__circle',
                                    isDone ? 'ps-stepper__circle--done' : '',
                                    isActive ? 'ps-stepper__circle--active' : '',
                                ].join(' ')}
                            >
                                {isDone ? (
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                ) : (
                                    <span>{i + 1}</span>
                                )}
                            </div>
                            <span className={`ps-stepper__label${isActive ? ' ps-stepper__label--active' : ''}`}>
                                {label}
                            </span>
                        </div>
                        {i < STEP_LABELS.length - 1 && (
                            <div className={`ps-stepper__line${isDone ? ' ps-stepper__line--done' : ''}`} />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
